import { memo } from 'react';
import useLoginState from '../../../core/hooks/useLoginState';
import ProductStockIndicator from '../../../availability/components/ProductStockIndicator';
import useProductQuantity from '../../queries/useProductQuantity';
import styles from './ProductTileAvailability.module.css';

const ProductTileAvailability = ({
    persistMessage = false,
    reduced = false,
    hasVariants = false,
    skuList,
    activeSKU,
    vertical,
}: {
    persistMessage?: boolean;
    reduced?: boolean;
    hasVariants?: boolean;
    skuList: string[];
    activeSKU?: string;
    vertical?: boolean;
}) => {
    const isLoggedIn = useLoginState();
    const { quantity } = useProductQuantity({ sku: activeSKU });

    if (!isLoggedIn || reduced) {
        return <div className={styles.availabilityIndicatorPlaceholder} />;
    }

    const props = hasVariants && !activeSKU ? { skuList } : { sku: activeSKU };

    return (
        <ProductStockIndicator
            {...props}
            hideBranchesWithoutAvailability
            hideSecondaryBranchWhileLoading
            messageStyle={persistMessage ? 'right' : 'tooltip'}
            desiredQuantity={quantity}
            skipLoadingStocks={false}
            vertical={vertical}
        />
    );
};

export default memo(ProductTileAvailability);
